module.exports = __webpack_public_path__ + "static/media/linkden.c0c32ea6.svg";